var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.showComponent)?_c('div',{key:_vm.componentRefresh,attrs:{"title":_vm.qaAble ? _vm.showIfHasPermission?.toString() : null}},[_c('vue-editor',{model:{value:(_vm.input),callback:function ($$v) {_vm.input=$$v},expression:"input"}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }